import React, { ReactElement } from 'react'
import { PersonalWallet as Wallet } from '@/database/personalwallet'
import BaseWallet from './BaseWallet'

const PersonalWallet = React.memo(({ wallet }: { wallet: Wallet }): ReactElement => {
    return <BaseWallet wallet={wallet} title="PERSONAL WALLET" />
})

PersonalWallet.displayName = 'PersonalWallet'

export default PersonalWallet
